import {withSize} from '../../../../libs/shared/ui/src/hooks/sizeHooks';
import {VariableHeightScrollerBase} from './variableHeightScrollerBase';

/*
 * Props.
 */

export const VariableHeightScroller = withSize(VariableHeightScrollerBase);
